var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPxLoadAgain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "28px",
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "px-load-again") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "2.-Photo-loading-errors",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1a.-Photo-loading-error",
    transform: "translate(-39.000000, -468.000000)",
    fill: "#cbccd6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "::-Damage-type-options",
    transform: "translate(0.000000, 203.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Photo",
    transform: "translate(16.000000, 242.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37,23 C43.7565449,23 49.3951968,27.7862687 50.71037,34.1532205 L50.71037,34.1532205 L48.7689113,34.6445492 C47.6743407,29.1449922 42.8212278,25 37,25 C30.372583,25 25,30.372583 25,37 C25,43.627417 30.372583,49 37,49 C40.4065442,49 43.4815562,47.5805418 45.6658335,45.3008279 L43.7071068,43.3431458 C43.5118446,43.1478836 43.5118446,42.8313011 43.7071068,42.636039 C43.7836052,42.5595405 43.8828517,42.5099173 43.9899495,42.4946176 L49.7646549,41.6696597 C50.0380219,41.6306073 50.2912879,41.8205568 50.3303403,42.0939238 C50.3370406,42.1408261 50.3370406,42.1884428 50.3303403,42.2353451 L49.5053824,48.0100505 C49.46633,48.2834175 49.213064,48.473367 48.939697,48.4343146 C48.8325992,48.4190149 48.7333527,48.3693916 48.6568543,48.2928932 L47.0801121,46.715542 C44.5336733,49.356928 40.9587167,51 37,51 C29.2680135,51 23,44.7319865 23,37 C23,29.2680135 29.2680135,23 37,23 Z",
    id: "px-load-again",
    transform: "translate(36.855185, 37.000000) scale(1, -1) translate(-36.855185, -37.000000) "
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPxLoadAgain);
export default __webpack_public_path__ + "static/media/px-load-again.0c8dfa683d6dfe5cdc454e777bbcafd4.svg";
export { ForwardRef as ReactComponent };